/**
 * Created by MinhQuan on 1/3/2017.
 */

angular.module('arctic.tariff.callback', ['common.helper', 'pascalprecht.translate'])
    .controller('CallbackController', function ($state, CONSTANTS) {
        var callbackCtrl = this;
        callbackCtrl.init = function(){
            $state.go(CONSTANTS.menu.landingPage);
        };
    });



// WEBPACK FOOTER //
// ./app/callback/cb.js